import { HrznGatewayMswBuilder } from '../../stories/HrznGatewayMswBuilder'

/** used to assign an msw builder, commonly baseMswBuilder from storyUtils within a given
 * query hooks directory, and assigns it to the msw manager
 *
 * @author Triston Armstrong
 */
export function useMswManager(builderOrBList: HrznGatewayMswBuilder | HrznGatewayMswBuilder[]): void {
  if (builderOrBList instanceof Array) {
    const newBuilder = HrznGatewayMswBuilder.create()
    builderOrBList.forEach(build => newBuilder.include(build))
    const b = newBuilder.build()
    return window.MswManager?.assignHandler(b)
  }

  if (builderOrBList instanceof HrznGatewayMswBuilder) {
    const b = builderOrBList.build()
    return window.MswManager?.assignHandler(b)
  }

  throw new Error("'What are you giving me?' - said the builder")
}
